<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-sliders"></i></div>
      <div>
        Paramètres généraux
        <div class="page-title-subheading">Réglages généraux de la plateforme</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
  

    

    <div class="row">
        <div class="col-lg-12">
            <div class="card" *ngIf="data!=undefined">
                <form #addForm="ngForm" (ngSubmit)="setData(addForm.value)">
                        
                <div class="card-body">
               
                    <div class=" form-group col-12 mb-3">
                        <label for="">Nom directeur <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="director_name"  class="form-control" [(ngModel)]="data.director_name">
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="director_phone" class="form-control"  [(ngModel)]="data.director_phone">
                    </div>

                    <div class=" form-group col-12 mb-3">
                        <label for="">Profil à attribuer à la création automatique de compte enseignant <span class="text-danger ml-2">(*)</span></label>
                        <ng-select name="role_for_professor" [(ngModel)]="data.role_for_professor">
                            <ng-option *ngFor="let r of roles" [value]="r.id">{{r.name}}</ng-option>
                        </ng-select>
                    </div>
                  

                    <div class=" form-group col-12 mb-3">
                        <label for="">Profil à attribuer à la création automatique de compte apprenant <span class="text-danger ml-2">(*)</span></label>
                        <ng-select name="role_for_student" [(ngModel)]="data.role_for_student">
                            <ng-option *ngFor="let r of roles" [value]="r.id">{{r.name}}</ng-option>
                        </ng-select>
                    </div>

                    <div class=" form-group col-12 mb-3">
                        <label for="">Profil à attribuer à la création automatique de compte parent apprenant <span class="text-danger ml-2">(*)</span></label>
                        <ng-select name="role_for_parent" [(ngModel)]="data.role_for_parent">
                            <ng-option *ngFor="let r of roles" [value]="r.id">{{r.name}}</ng-option>
                        </ng-select>                    
                    </div>
                  
                  
                </div>

                <div class="card-footer">
                    <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading"  >Sauvegarder les données <app-loading [isVisible]="loading"></app-loading></button>
                  </div>
              </form>
            </div>
        </div>
    </div>